export default __webpack_public_path__ + "static/media/ic-decline.984a62d0.svg";